import React, { useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom'; 
import Swal from 'sweetalert2'; 
import './otp.css';

const Otp = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { serviceId, pid, serviceName } = location.state || {}; 
    const msisdn = sessionStorage.getItem('decryptedMsisdn'); 

    const [otp, setOtp] = useState(['', '', '', '']);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    // Handle input change
    const handleChange = (index, value) => {
        const newOtp = [...otp];
        newOtp[index] = value;

        // Move focus to next input field
        if (value && index < otp.length - 1) {
            document.getElementById(`otp-input-${index + 1}`).focus();
        }

        setOtp(newOtp);
    };

    // Handle key down events
    const handleKeyDown = (event, index) => {
        const { key, keyCode } = event;
        if (key === "Backspace") {
            if (index > 0) {
                document.getElementById(`otp-input-${index - 1}`).focus();
            }
        } else if (keyCode >= 48 && keyCode <= 57) { // Numeric keys only
            handleChange(index, event.key);
            event.preventDefault();
        }
    };

    const validateOtp = async () => {
        const encryptedMsisdn = sessionStorage.getItem("encryptedMsisdn");
        const otpValue = otp.join('');
        setLoading(true);
        setError('');
        setSuccess('');
    
        try {
            const headers = {
                "Content-Type": "application/json",
                Authorization: "Basic RE9UVXNlcm5hbWUxOkRPVFBhc3MyMTNAIQ==",
                PartnerId: "partner-a5d477b9-c77c-48d5-b9d0-df2d71370680",
                Accept: "application/json"
            };
    
            // Debugging information
            console.log('Sending API request with the following data:');
            console.log('msisdn:', msisdn);
            console.log('otp:', otpValue);
            console.log('pid:', pid);

    
            const response = await axios.post(
                'https://bankalfalah.webddocsystems.com/smosa.php/verifyOTP',
                {
                    msisdn,
                    otp: otpValue,
                    pid,
                },
                { headers }
            );
    
            const responseData = response.data;
    
            console.log('API Response:', response); // Log the entire response object
            console.log('Response Data:', responseData); // Log the actual response data
    
            if (typeof responseData === 'string' && responseData.includes('<div')) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Server returned an unexpected response. Please try again later.',
                    confirmButtonText: 'OK'
                });
            } else if (typeof responseData === 'object') {
                // Handle JSON responses as before
                if (responseData.resultCode === '0') {
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: 'OTP validated successfully! Your package has been subscribed.',
                        confirmButtonText: 'OK'
                    }).then(() => {
                        window.location.href = `/?msisdn=${encodeURIComponent(encryptedMsisdn)}`;
                    });
                } else if (responseData.resultCode === '101') {
                    Swal.fire({
                        icon: 'error',
                        title: 'Invalid OTP',
                        text: 'The OTP you entered is incorrect. Please try again.',
                        confirmButtonText: 'OK'
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `Unexpected error: ${responseData.resultDesc}`,
                        confirmButtonText: 'OK'
                    });
                }
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Unexpected response format received.',
                    confirmButtonText: 'OK'
                });
            }
        } catch (error) {
            console.error('Error validating OTP:', error.response ? error.response.data : error.message);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred, please try again.',
                confirmButtonText: 'OK'
            });
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <div className="container mt-5 d-flex justify-content-center align-items-center">
            <div className="position-relative">
                <div className="p-2 text-center">
                    <h4>Please enter the one-time password <br /> to verify your account</h4>
                    <div>
                        <p>A code has been sent to</p> 
                        <span>{msisdn}</span>
                    </div>
                    <div id="otp" className="inputs d-flex flex-row justify-content-center mt-2">
                        {otp.map((value, i) => (
                            <input
                                key={i}
                                id={`otp-input-${i}`}
                                className="m-2 text-center form-control rounded"
                                type="text"
                                maxLength="1"
                                value={value}
                                onChange={(e) => handleChange(i, e.target.value)}
                                onKeyDown={(e) => handleKeyDown(e, i)}
                            />
                        ))}
                    </div>
                    <div className="mt-4">
                        <button 
                            className="btn btn-danger px-4 validate"
                            onClick={validateOtp}
                            disabled={loading}
                        >
                            {loading ? 'Validating...' : 'Validate'}
                        </button>
                        {error && <div className="mt-2 text-danger">{error}</div>}
                        {success && <div className="mt-2 text-success">{success}</div>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Otp;
